import CardBox from "@/src/mui-custom/card/card-box/card-box";
import CardTitleContainer from "@/src/mui-custom/card/card-title-container/card-title-container";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faNewspaper} from "@fortawesome/pro-duotone-svg-icons";
import CardTitleText from "@/src/mui-custom/card/card-title-text/card-title-text";
import CardTitleBox from "@/src/mui-custom/card/card-title-box/card-title-box";
import CardTitleDivider from "@/src/mui-custom/card/card-title-divider/card-title-divider";
import CardBodyBox from "@/src/mui-custom/card/card-body-box/card-body-box";
import ReactHtmlParser from "react-html-parser";
import {Typography} from "@mui/material";
import Journal from "@/src/_types/journal";

const Index = ({welcomeMsg}: { journal: Journal, welcomeMsg: any }) => {

    return (
        <CardBox
            sx={{
                display: 'flex',
                paddingX: {xs: '.5rem', sm: '.75rem', md: '.75rem', lg: '1.5rem', xl: '1.5rem'},
                paddingTop: '1.5rem',
                paddingBottom: '3rem',
                justifyContent: 'left',
                flexWrap: 'wrap',
                minWidth: '100%'
            }}
        >
            <CardTitleContainer sx={{
                paddingLeft: '.5rem',
                marginBottom: '1.5rem',
            }}>
                <CardTitleContainer>
                    <CardTitleBox>
                        <FontAwesomeIcon icon={faNewspaper} className={'icon'}/>
                        <CardTitleText variant={"h2"}>
                            Welcome
                        </CardTitleText>
                    </CardTitleBox>
                    <CardTitleDivider/>
                </CardTitleContainer>
            </CardTitleContainer>
            <CardBodyBox>
                {welcomeMsg?.content ?
                    ReactHtmlParser(
                        welcomeMsg?.content
                    ) :
                    <>
                        <Typography component={'h2'} fontWeight={'bold'} marginBottom={1.2} color={'text.primary'}>
                            Dear Colleagues,
                        </Typography>
                        <Typography color={'text.primary'} marginBottom={1.2}>
                            I, as the editor-in-chief, and on behalf of our editorial board would like to
                            announce establishment of the current journal website.
                            All papers in the field of journal are more than welcomed to our journal.
                        </Typography>
                        <Typography color={'text.primary'} marginBottom={1.2}>
                            Kind Regards, <br/>
                            Editor-in-chief
                        </Typography>
                    </>
                }
            </CardBodyBox>
        </CardBox>
    )
}

export default Index;
